<!-- src/components/ezer/EzerMessages.vue -->
<template>
  <div class="ezer-messages" ref="container">
    <template v-for="msg in messages" :key="msg.id">
      <!-- User bubble -->
      <EzerUserBubble v-if="msg.role === 'user'" :text="msg.content" />

      <!-- Assistant bubble -->
      <EzerAssistantBubble
        v-else-if="msg.role === 'assistant'"
        :text="msg.content"
        :tool-calls="msg.toolCalls"
      />

      <!-- Tool results are hidden from the user (handled internally) -->
    </template>

    <!-- Streaming indicator -->
    <EzerAssistantBubble
      v-if="streamingText"
      :text="streamingText"
      :is-streaming="true"
    />

    <!-- Feedback prompt (after last assistant message, when not loading/streaming) -->
    <EzerFeedback
      v-if="feedbackState && !isLoading && !streamingText"
      :feedback-state="feedbackState"
      @feedback="(val) => $emit('feedback', val)"
      @request-admin="$emit('request-admin')"
      @dismiss-feedback="$emit('dismiss-feedback')"
    />

    <!-- Thinking indicator -->
    <EzerThinkingIndicator v-if="isLoading && !streamingText" />
  </div>
</template>

<script>
import { ref, watch, nextTick } from 'vue'
import EzerUserBubble from './EzerUserBubble.vue'
import EzerAssistantBubble from './EzerAssistantBubble.vue'
import EzerFeedback from './EzerFeedback.vue'
import EzerThinkingIndicator from './EzerThinkingIndicator.vue'

export default {
  name: 'EzerMessages',
  components: { EzerUserBubble, EzerAssistantBubble, EzerFeedback, EzerThinkingIndicator },
  props: {
    messages: Array,
    streamingText: String,
    isLoading: Boolean,
    feedbackState: { type: String, default: null },
  },
  emits: ['feedback', 'request-admin', 'dismiss-feedback'],
  setup(props) {
    const container = ref(null)
    function scrollToBottom() {
      nextTick(() => {
        if (container.value) {
          container.value.scrollTop = container.value.scrollHeight
        }
      })
    }
    watch(() => props.messages.length, scrollToBottom)
    watch(() => props.streamingText, scrollToBottom)
    watch(() => props.isLoading, scrollToBottom)
    return { container }
  },
}
</script>
